import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {BaseComponent} from '../../../core/base.component';
import {HeaderService} from '../../../core/services/header.service';
import {AuthService} from '../../../core/security/auth.service';
import {NotificationService} from '../../../notification/notification.service';
import {CustomReportsService} from '../custom-reports.service';
import {MatConfirmDialogComponent} from '../../../dialogs/mat-confirm/mat-confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';

@Component({
    selector: 'app-custom-report-unsubscribe',
    templateUrl: './unsubscribe.component.html',
    styleUrls: ['./unsubscribe.component.scss'],
    standalone: true,
    imports: [MatButton, Angular2PromiseButtonModule],
})
export class CustomReportUnsubscribeComponent extends BaseComponent implements OnInit, OnDestroy {

  buttonSubmitPromise: Promise<void>;
  unsubscribeObject: { email: string; reportId: string; profileId: string; reportName: string; };
  buttonUnsubscribePromise: Promise<void>;

  private paramsSubscription;


  constructor(route: ActivatedRoute, headerService: HeaderService, titleService: Title, authService: AuthService,
              public customReportsService: CustomReportsService,
              public dialog: MatDialog,
              private router: Router,
              private notificationService: NotificationService) {
    super(route, headerService, titleService, authService);
  }

  async ngOnInit() {
    await super.ngOnInit();

    const unsubscribeDataParam = this.route.snapshot.queryParams['i'];
    console.log(unsubscribeDataParam);
    const unsubscribeDataString = atob(unsubscribeDataParam);
    console.log(unsubscribeDataString);
    if (unsubscribeDataString) {
      this.unsubscribeObject = JSON.parse(unsubscribeDataString);
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.paramsSubscription?.unsubscribe();
    this.headerService.hideSearchInput();
  }

  unsubscribeConfirm() {
    if (this.unsubscribeObject) {
      const dialogRef = this.dialog.open(MatConfirmDialogComponent, {
        // width: '250px',
        data: {
          title: 'Unsubscribe?',
          text: 'Are you sure you want to stop receiving reporting emails?',
          actionTitle: 'Yes',
        }
      });

      dialogRef.afterClosed().subscribe(async (result) => {
        if (result) {
          this.buttonUnsubscribePromise = this.unsubscribe();
        }
      });
    }
  }

  async unsubscribe() {
    await this.customReportsService.unsubscribeCustomReport(this.unsubscribeObject);
    await this.notificationService.notifySuccess(`You successfully unsubscribed from "${this.unsubscribeObject.reportName}" report.`);
    await this.returnHome();
  }

  async returnHome() {
    await this.router.navigate(['/home']);
  }
}
